import React from 'react';
import css from './EMIDPCard.scss';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Card } from 'panamera-react-ui';

const EMIDPCard = props => {
    const { item, intl } = props;

    const translations = {
        titleAdp: intl.formatMessage({ id: 'estimatedCreditWithoutColon', defaultMessage: 'Estimasi Perhitungan Kredit' }),
        downPayment: intl.formatMessage({ id: 'downPayment' }),
        installment: intl.formatMessage({ id: 'installment' }),
        installmentTenure: intl.formatMessage({ id: 'installmentTenure' }, { amount: item?.price?.value?.emi?.monthly_installment?.display, tenure: item?.price?.value?.emi?.tenure })
    };

    return (
        <Card className={ css.itemAdpCard }>
            <div className={ css.adpContainer }>
                <div className={ css.titleAdp }>
                    <span>{ translations.titleAdp }</span>
                </div>
                <div className={ css.adpWrapper }>
                    <p className={ css.labelAdp }>{ translations.downPayment }</p>
                    <p className={ css.amountAdp }>
                        {item.price.value.emi.down_payment.display}
                    </p>
                </div>
                <div className={ css.adpWrapper }>
                    <p className={ css.labelAdp }>{ translations.installment }</p>
                    <p className={ css.amountAdp }>
                        { translations.installmentTenure }
                    </p>
                </div>
            </div>
        </Card>
    );
};

EMIDPCard.propTypes = {
    item: PropTypes.object.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

export default compose(injectIntl)(EMIDPCard);
